
<div class="row mb-2">
  @if (!isUploading) {
    <div class="col-12">
      <div appMessageDirective [variant]="MessageVariant.Outlined" [severity]="MessageSeverity.LBColors">{{'i18n.domain.assets.asset-storage.edit-asset-storage.upload-hint' | translate}}</div>
    </div>
  }
</div>
<div class="row mb-2">
  <div class="col-12">
    <div #dropArea id='dropArea'>
      <ejs-uploader #multiUploader
                    multiple="true"
                    maxFileSize="5e+9"
                    [asyncSettings]="asyncSettings"
                    [dropArea]="dropArea"
                    [autoUpload]="false"
                    (uploading)="onUploading($event)"
                    (actionComplete)="onActionComplete($event)"
                    (chunkUploading)="onChunkUploading($event)"
                    (chunkSuccess)="onChunkSuccess($event)"
                    (failure)="onFailure($event)"
                    (selected)="onFilesSelected($event)"
                    (canceling)="onCanceling($event)"
                    (removing)="onRemoving($event)"
                    (clearing)="clearUploaderVariables()">
      </ejs-uploader>
    </div>
  </div>
</div>
